export default {
  data () {
    return {
      mapData: {},
    }
  },

  methods: {
    setMapData (json) {
      this.mapData = json
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/googleMap/HotelMapMixin.js